const intervals = {
  month: "mo",
};
export { intervals };
